export default "__VITE_ASSET__6683af12__"